<template>
    <div class="row">
        <div class="col-12 col-md-12 note-head">
            <div class="note-title">
                <h4>{{ note.name }}</h4>
            </div>
            <div class="note-btn d-flex align-items-center" v-if="!note.isHideAddBtn">
                <button @click="onOpenModal(note, index)" type="button" class="btn btn-outline-primary btn-sm btn-block">
                    <i v-if="!salesOrderId" class="fas fa-plus"></i>
                    <i v-else class="fas fa-pen"></i>
                </button>
            </div>
        </div>
        <div class="col-21">
            <hr class="mt-0">
        </div>
        <div class="col-12 col-md-12 note-body">
            <div class="table-container">
                <table class="table create-billing table-width">
                    <thead>
                        <tr>
                            <th class=" pl-10 particular">Item Details</th>
                            <th>Doctor</th>
                            <th>Schedule</th>
                            <th>Dentition Plan</th>
                            <th>Bill Dentition</th>
                            <th>Bill Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody ref="tableRef">
                        <tr v-for="(item, noteIndex) in note.selectedNotes"
                            :key="noteIndex"
                            :style="{
                            backgroundColor: parseInt(item.id) == parseInt(generalId) ? '#bbf7d0' : '',
                            color: parseInt(item.id) == parseInt(generalId) ? '#166534' : '',
                          }"
                        >
                            <td class="pl-10">{{ item.name }}</td>
                            <td>{{ item.service_resource ? item.service_resource.name : '' }}</td>
                            <td>{{ item.schedule_date ? formatDate(new Date(item.schedule_date)) : '' }}</td>
                            <td>{{ item.dentition ?  item.dentition.join(", ") : ''}}</td>
                            <td>{{ getDentitionPertains(item.dentition_pertains) }}</td>
                            <td>{{ item.total }}</td>
                            <td v-html="getStatus(item.status)"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <AddTreatmentPlan
            :selectedNotes="note.selectedNotes"
            v-model:isOpenModal="isOpenModal" 
            v-if="isOpenModal"
            :dentition="dentition"
            :dentitionType="dentitionType"
        />
    </div>
</template>

<script setup>
import {computed, ref} from "vue"
import { convertToTitleCase } from '@/services/utils/global';
import AddTreatmentPlan from './AddTreatmentPlan.vue';
import { formatDate } from '@/services/utils/global.js';
import {useRoute} from "vue-router";

const props = defineProps({
    note: {
        type: Object,
        default: () => {}
    },
    index: {
        type: Number,
        default: -1,
    },
    salesOrderId: {
        type: Number || null,
        default: null,
    },
    generalId: {
        type: Number || null,
        default: null,
    },
    dentition: {
        type: Object || null,
        default: () => {}
    },
    dentitionType: {
        type: String || null,
        default: null,
    }
})

const route = useRoute();
const generalId = computed(() => route.query.general_id);

const emit = defineEmits(['openModal']);
const isOpenModal = ref(false)
const onOpenModal = (note, index = -1) => {
    if(note.value){
        note.name = convertToTitleCase(note.value);
    }
    
    isOpenModal.value = true
}

const onRemoveNote = (noteName, selectedIndex) => {
    props.note.selectedNotes.splice(selectedIndex, 1);
}

const getStatus = (status) => {
    if(! status) return '';
    if(status === 'pending') {
        return `<span class="badge bg-warning">Ongoing</span>`;
    } else if(status === 'completed') {
        return `<span class="badge bg-success"><i class="fas fa-check"></i> Completed</span>`;
    }
}

const getDentitionPertains = (dentitionPertains) => {
    if (!dentitionPertains || dentitionPertains.length < 0) return '';
    return dentitionPertains.filter(dentition => dentition.is_billed).map(dentition => dentition.tooth_number).join(', ').toUpperCase();
}

</script>

<style scoped>
.note-title {
    min-width: 200px;
}
.note-body .card-body{
    padding: 0 2%;
}
.note-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}
.action .close {
    color: red;
    cursor: pointer;
}
.note-body .card {
    background: #f9f9f9;
    min-height: 100px;
    margin-bottom: 1rem;
}
.medicine {
    display: flex;
    justify-content: space-between;
    margin: 3% 0;
    align-items: center;
    position: relative;
}
</style>